import { render } from "./ResetSuccess.vue?vue&type=template&id=823b4bec"
import script from "./ResetSuccess.vue?vue&type=script&lang=js"
export * from "./ResetSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__